export const version = 'kunde-v1.20.0-SNAPSHOT-ba300ca8083baf6142b1b4298f781be62f1b583e';